import { z } from 'zod';

export const AuthSchema = z.object({
    email: z.string().email(),
    password: z.string().min(6),
});

/** `email` field carries legacy login identifier (e-mail or userName). */
export const LoginSchema = z.object({
    email: z.string().min(1, { message: 'form.validation.invalidEmail' }),
    password: z.string().min(1, { message: 'form.validation.passwordRequired' }),
    username: z.string().optional(),
    tenantId: z.string().regex(/^[0-9a-fA-F]{24}$/).optional(),
    authMethod: z.enum(['local', 'ldap']).optional()
});

export const ActivateAccountSchema = z.object({
    token: z.string().min(16),
    password: z.string().min(6),
    confirmPassword: z.string().min(6)
}).refine((d) => d.password === d.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword']
});

export const RegisterSchema = z.object({
    email: z.string().email(),
    password: z.string().min(6),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
});

export const CreateAuthSchema = AuthSchema.omit({ id: true });
export const UpdateAuthSchema = AuthSchema;